import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=6d31ac7b"
import script from "./ChatThread.vue?vue&type=script&lang=js"
export * from "./ChatThread.vue?vue&type=script&lang=js"
import style0 from "./ChatThread.vue?vue&type=style&index=0&id=6d31ac7b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports